import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setRestaurants = info => {
	return {
		type: ActionTypes.LOAD_RESTAURANTS,
		restaurants: info.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadRestaurants = () => {
	return dispatch => {
		axios
			.get("https://getupstudio.co/solanasapi/gastronomia")
			.then(response => {
				dispatch(setRestaurants(response.data));
			})
			.catch(error => {});
	};
};

export const saveRestaurant = (restaurant) => {

	console.log(restaurant);

	return dispatch => {
		axios
			.post(
				"https://getupstudio.co/solanasapi/gastronomia/edit",
				restaurant
			)
			.then(response => {
				dispatch(loadRestaurants());
			})
			.catch(error => {});
	};
};
